import { useState, useEffect, useContext } from 'react';
import UserDetailsContext from '../Dashboard/UserDetailsContext';
import { useExpenseStore } from '../store/useExpenseStore';

const UseFeatureFlags = () => {
  const [featureFlags, setFeatureFlags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const userDetails = useContext(UserDetailsContext);
  // Do NOT subscribe the hook to the entire store to avoid unnecessary re-renders
  // We'll access actions/state via useExpenseStore.getState() inside effects

  const teamId = userDetails?.userDetails?.TeamContactID;

  useEffect(() => {
    if (!teamId) {
      setIsLoading(false);
      return;
    }

    let mounted = true;
    (async () => {
      try {
        setIsLoading(true);
        setError(null);
        const state = useExpenseStore.getState();
        const loadedAt = state.lastLoadedAt?.featureFlags?.[teamId];
        if (loadedAt) {
          // Already cached for this session
          if (!mounted) return;
          setFeatureFlags(state.getFeatureFlags(teamId));
          setIsLoading(false);
          return;
        }
        // Call action from a stable reference to avoid effect dependency on store object
        await state.loadFeatureFlags(teamId);
        if (!mounted) return;
        const list = useExpenseStore.getState().getFeatureFlags(teamId);
        setFeatureFlags(list);
        setIsLoading(false);
      } catch (e) {
        if (!mounted) return;
        setError(e);
        setIsLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, [teamId]);

  const hasFeature = (featureName) => {
    const feature = featureFlags.find(flag => flag.FeatureFlag === featureName);
    return feature ? feature.Granted : false;
  };

  return {
    featureFlags,
    isLoading,
    error,
    hasFeature,
  };
};

export default UseFeatureFlags;
